import { AfterViewInit, Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { map, startWith } from 'rxjs';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { IconComponent } from '../general/icon/icon.component';
import { MatCardModule } from '@angular/material/card';
import { OverlayContainer } from '@angular/cdk/overlay';
import { LoginResults } from '../../../login/login.viewmodel';
import { CACHE_KEYS } from '../../constants/cache-keys';
import { CacheService } from '../../services/cache.service';
@Component({
    selector: 'nuc-auto-search',
    imports: [ReactiveFormsModule, MatAutocompleteModule, MatInputModule, IconComponent, MatCardModule, NgIf],
    templateUrl: './auto-search.component.html',
    styleUrl: './auto-search.component.scss',
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AutoSearchComponent),
            multi: true
        }
    ]
})
export class AutoSearchComponent implements ControlValueAccessor, OnInit, OnChanges, AfterViewInit {
  @Input() label: string = "";
  @Input() type: string;
  @Input() class: string;
  @Input() suffix: string;
  @Input() prefix: string;
  @Input() hint: string;
  @Input() maxLength: number;
  @Input() min: number;
  @Input() max: number;
  @Input() required: boolean;
  @Input() placeholder: string = "";
  @Input() formControl: FormControl | null = null;
  @Input() errorMessage: string = "Invalid input";
  @Input() name: string;
  @Input() displayClass: string;
  @Input() iconColor: string;
  @Input() filterKeys: string[];
  //@Input() disabled: boolean;
  @Input() options: any[] = [];
  filteredOptions: any[];
  value: string = "";
  myControl = new FormControl('');
  searchResults: any[] = [];
  userType: string;
  onChange = (value: string) => { };
  onTouched = () => { };
  loginData: LoginResults;
  @Output() optionSelected = new EventEmitter<any>();
  @Output() inputCleared = new EventEmitter<any>();
  @Output() textCleared = new EventEmitter<any>();
  @ViewChild(MatAutocomplete) autocomplete!: MatAutocomplete;
  constructor(private overlayContainer: OverlayContainer, private cacheService: CacheService) { }
  ngOnInit(): void {   
    this.loginData =  this.cacheService.getFromCache(CACHE_KEYS.LOGIN.LOGIN_DATA);
    this.userType = this.loginData?.userType;
    this.type = this.type || "text";
    this.placeholder = this.placeholder || this.label;
    this.maxLength = this.maxLength || 200;

    this.formControl.valueChanges.subscribe(value => {
      this.suffix = value ? 'close' : 'search';
      this.formControl.value?.length == 0 && this.inputCleared.emit('cleared');
    });

    this.formControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    ).subscribe(filtered => this.filteredOptions = filtered);
  }

  clearInput() {
    this.formControl.setValue('');
    this.inputCleared.emit('cleared');  
  }

  onEnterPress(event: KeyboardEvent){
    if(event.key === 'Enter'){
      this.textCleared.emit('textCleared');
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.required) {
      if (this.label.indexOf("*") == -1) {
        this.label = `${this.label}*`;
      }
    } else {
      if (this.label.indexOf("*") != -1) {
        this.label = this.label.replace("*", "");
        // this.label = this.label.substring(0, this.label.length - 1);
      }
    }
  }

  highlightMatch(text: string): string {
    const search = this.formControl.value;
    if (!search) {
      return text;
    }
    const regex = new RegExp(`(${search})`, 'gi');
    let highlightedText = text?.replace(regex, '<b>$1</b>');
    
    // Replace spaces with non-breaking spaces to preserve them
    highlightedText = highlightedText?.replace(/ /g, '&nbsp;');
    
    return highlightedText;
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onOptionSelected(event: any) {
    const selectedOption = this.options.find(option => option.label === event.option.value);
    this.optionSelected.emit(selectedOption);
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase(); // Keep the spaces but make the comparison case-insensitive
  }
  
  private _filter(value: string): any[] {
    const filterValue = value?.toLowerCase(); // Normalize input
    if (this.filterKeys) {
      return this.options.filter(obj =>
        this.filterKeys.some(key => obj[key] && obj[key].toString().toLowerCase().includes(filterValue))
      );
    } else {
      return this.options?.filter(item => this._normalizeValue(item).includes(filterValue));
    }
  }
  

  ngAfterViewInit(): void {
    this.autocomplete.opened.subscribe(() => {
      // this.addClassToOverlay();
      const overlayPane = this.overlayContainer.getContainerElement().querySelector('.mat-mdc-autocomplete-panel');
      if (overlayPane) {
        overlayPane.closest('.cdk-overlay-pane')?.classList?.add(`custom-auto-search-${this.displayClass}`);
      }
    });

    this.autocomplete.closed.subscribe(() => {
      // this.removeClassFromOverlay();
      const overlayPane = this.overlayContainer.getContainerElement().querySelector('.mat-mdc-autocomplete-panel');
      if (overlayPane) {
        overlayPane.closest('.cdk-overlay-pane')?.classList?.remove(`custom-auto-search-${this.displayClass}`);
      }
    });
  }
}
